<template>
    <span>{{ price(params) }}</span>
</template>

<script>
    export default {
        name: 'CellRendererPrice',
        computed: {
          price() {
            return ( v ) => {
              return v.value + ' ' +v.data.currency
            }
          }
        }
    }
</script>
